// Module
var code = "<h3>Outlines</h3> <ul class=\"slide-menu-items\"> <li class=\"slide-menu-item\"><a href=\"#/leveldb\">LevelDB</a></li> </ul> ";
// Exports
export default code;